Namespace 'Monitoring.Models.SocialContents'

class Monitoring.Models.SocialContents.WebchatStart extends Backbone.Model

  constructor: (start) ->
    @start = start

  getJson: ->
    @start

  getGroupType: ->
    "webchat"

  getType: ->
    "webchat"

  getSubType: ->
    "webchat-start"

  getPrivacy: ->
    'private'

  getContentId: ->
    @start.content_id

  isBrandContent: ->
    false

  hasUser: ->
    true

  hasProfile: ->
    true

  hasRelated: ->
    false

  hasShares: ->
    false

  getAuthorId: ->
    @start.session.id

  getAuthorName: ->
    @start.author.name

  getAvatar: ->
    window.image_path(@getSubType() + '.png')

  getCreatedAt: ->
    moment(parseInt(@start.created_at))

  getMainText: ->
    ''

  getCustomFields: ->
    @start.custom_fields

  getCustomFieldsAsString: ->
    _.map(@getCustomFields(), (value, key) =>
      "#{key}: #{value}"
    ).join(" - ")

  hasAttachments: ->
    false

  getAttachments: ->
    []

  getAuthorUsername: ->
    ''

  getWebchatHistory: ->
    @start.history or []

  type: ->
    @getType()

  getValue: (name) ->
    return @getValues()[name]

  getValues: ->
    return @get('data').content
